import React, {useState} from "react";

import {useDarkMode} from "../contexts/darkModeContext";
import { ReactComponent as CSRICON } from "../customIcons/CSR.svg";
import {formatTimestamp, formatTimeStampDate} from "./GLOBAL/GlobalFunctions";
import {ClockIcon} from "@heroicons/react/24/outline";

const CSRStatusCard = ({ CSR }) => {
    
    const { darkMode } = useDarkMode();
    
    const [reps] = useState(CSR.reps || []);
    
    const getLastSeenColor = (lastSeen) => {
        const now = Date.now(); // current time in ms
        const differenceInMinutes = (now - lastSeen) / (1000 * 60); // convert ms to minutes
    
        if (differenceInMinutes > 90) {
            return 'text-red-600'; // More than 90 min = red
        } else if (differenceInMinutes > 35) {
            return 'text-yellow-600'; // More than 35 min = yellow
        } else if (differenceInMinutes < 35) {
            return 'text-green-600'; // less than 35 min = green
        } else {
            return 'text-gray-500'; // No Data = gray (optional)
        }
    };

 
    return (
        <li key={CSR.id} className={`font-carlita h-fit col-span-1 overflow-hidden rounded-xl border ${darkMode ? 'border-neutral-700' : 'border-gray-200'} shadow-md grid`}>
            <div className={`flex items-center gap-x-4 border-b border-gray-900/5 ${darkMode ? 'bg-darkBgColor' : 'bg-gray-50'} p-6`}>
                <CSRICON className={`size-12 ${getLastSeenColor(CSR.lastSeen)}`}/>
                <div className={``}>
                    <div className="text-sm/6 font-medium text-xl">{CSR.name}</div>
                    <div className="text-sm/6 font-medium text-sm text-gray-500">Created: {CSR.created}</div>
                </div>
                
                <div className={`flex items-center ml-auto gap-x-3 ${getLastSeenColor(CSR.lastSeen)}`}>
                    <ClockIcon className={`size-8`}/>
                    <div className={``}>
                        <div className={`text-sm font-bold`}>Last Seen</div>
                        <div className={`text-xs -mt-1`}>{formatTimestamp(CSR.lastSeen) || "No Data"}</div>
                    </div>
                </div>
                
            </div>
            <dl className={`-my-3 divide-y ${darkMode ? 'divide-neutral-700' : 'divide-gray-100'} px-6 py-4 text-sm/6`}>
                
                {reps.map((rep, index) =>
                    <div className="flex justify-between gap-x-4 py-3">
                        <dt className="text-gray-500">Sales Rep:</dt>
                        <dd className="">{rep.name || ""}</dd>
                    </div>
                )}
            </dl>
        </li>
    )
}

export default CSRStatusCard;
